import { QuoteDetails } from '@domgen/dgx-fe-basket';
import { CustomerDetails } from '@domgen/dgx-fe-common';
import { RegistrationApplianceDetails } from '../registration-appliance-details/registration-appliance-details.interface';

export interface RegistrationRequest {
  basketId?: string;
  basketItemId?: string;
  item: RegistrationApplianceDetails;
  person: CustomerDetails;
  quote?: QuoteDetails;
  quoteId?: string;
  extraInfo?: {
    cardType: 'Premier' | 'Platinum';
  };
}
